<template>
  <!-- eslint-disable vue/no-v-html -->
  <p
    v-if="html && !hasHtml && !segments"
    class="dn-text"
    v-html="html"
  />
  <!-- eslint-disable vue/no-v-html -->
  <div
    v-else-if="html && hasHtml && !segments"
    class="dn-text"
    v-html="html"
  />
  <div
    v-else-if="segments"
    class="dn-text"
  >
    <template
      v-for="(segment, index) in segments"
      :key="index"
    >
      <span
        v-if="segment.type === 'text'"
        v-html="segment.html"
      />
      <atlas-word-explainer
        v-else-if="segment.type === 'explain'"
        :title="segment.word"
        :content="segment.explanation"
      >
        {{ segment.word }}
      </atlas-word-explainer>
    </template>
  </div>
</template>
<script setup lang="ts">
import { AtlasWordExplainer } from '@nhst/ui';
import type { TextSegment } from '~/types/articleInline';

const props = defineProps({
  /**
   * Article inline content
   * @param {String} html = "Html content"
   */
  html: {
    type: String,
    required: false,
    default: null
  },
  /**
   * Pre-parsed segments for paragraphs containing word explainers
   * @param {TextSegment[]} segments
   */
  segments: {
    type: Array as PropType<TextSegment[]>,
    required: false,
    default: null
  }
});

const hasHtml = computed(() => {
  const regex = /<[^>]*>/; // This regex checks for HTML tags

  return regex.test(props.html);
});
</script>

<style lang="scss">
.dn-text {
  font-family: var(--typography-editorial-body-min-font-family);
  font-weight: var(--typography-editorial-body-min-font-weight);
  font-size: var(--typography-editorial-body-min-font-size);
  line-height: var(--typography-editorial-body-min-line-height);

  @media only screen and (width >= 768px) {
    font-family: var(--typography-editorial-body-max-font-family);
    font-weight: var(--typography-editorial-body-max-font-weight);
    font-size: var(--typography-editorial-body-max-font-size);
    line-height: var(--typography-editorial-body-max-line-height);
  }

  a {
    color: var(--color-link-default);
    text-decoration: var(--text-decoration-style, underline);
    text-underline-offset: 5px;
    text-decoration-color: var(--color-brand-utility-200);
    text-decoration-thickness: 1px;
    transition: all 0.3s ease;

    &:hover {
      color: var(--color-link-hover);
      text-decoration-color: var(--color-link-hover);
    }

    &:active {
      color: var(--color-link-active);
    }
  }

  ol,
  ul {
    padding: 0 24px;

    li {
      font-family: var(--typography-editorial-body-min-font-family);
      font-weight: var(--typography-editorial-body-min-font-weight);
      font-size: var(--typography-editorial-body-min-font-size);
      line-height: var(--typography-editorial-body-min-line-height);

      @media only screen and (width >= 768px) {
        font-family: var(--typography-editorial-body-max-font-family);
        font-weight: var(--typography-editorial-body-max-font-weight);
        font-size: var(--typography-editorial-body-max-font-size);
        line-height: var(--typography-editorial-body-max-line-height);
      }
    }
  }
}
</style>
